import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { NativeFullScreenLayout } from '~/components/NativeFullScreenLayout/NativeFullScreenLayout';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export const GetUpdateRequiredWallTID = (parentTestId)=>getTestIds(parentTestId);
export const UpdateRequiredWall = (param)=>{
    let { testId } = param;
    const { UpdateRequiredWallTestIds } = useMemo(()=>GetUpdateRequiredWallTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('common.updateRequired');
    const { native } = useIoContext();
    // The gate renders this above NativeSplashOverlay, so nothing else dismisses the native splash.
    useEffect(()=>{
        void native.hideSplashScreen();
    }, []);
    return /*#__PURE__*/ _jsx(NativeFullScreenLayout, {
        testId: UpdateRequiredWallTestIds.Layout(),
        title: t.title(),
        body: t.body(),
        action: {
            label: t.cta(),
            onClick: ()=>native.openStore(),
            biName: 'native_update_required_cta'
        }
    });
};
